// extracted by mini-css-extract-plugin
export default {"expire-notice":"expire-notice___A9ENI","bar":"bar___Ulg0H","info":"info___Y85r4","left":"left___rTP7a","right":"right____Os_w","banned-mask":"banned-mask___f3Sk7"};